var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.componentClass,
      style: _vm.componentStyle,
      attrs: { type: "submit", disabled: _vm.isDisabled },
      on: { click: (event) => _vm.$emit("click", event) },
    },
    [
      _vm._v("\n  " + _vm._s(_vm.currentLabel) + "\n  "),
      _vm.iconName || _vm.isProcessing
        ? _c(
            "span",
            { staticClass: "margin-left-2xs" },
            [
              _vm.isProcessing
                ? _c(
                    "font-awesome-icon",
                    _vm._b(
                      {
                        attrs: {
                          icon: _vm.$v6[_vm.iconStyle][
                            _vm.isProcessingIconName
                          ],
                          size: _vm.iconSize !== "" ? _vm.iconSize : null,
                          "fixed-width": "",
                        },
                      },
                      "font-awesome-icon",
                      { [_vm.isProcessingIconAnimation]: true },
                      false
                    )
                  )
                : _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6[_vm.iconStyle][_vm.iconName],
                      size: _vm.iconSize !== "" ? _vm.iconSize : null,
                      "fixed-width": "",
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }